import React from 'react';

const FAQHeader: React.FC = () => {
  return (
    <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
      <h1 style={{ fontSize: '3rem', marginBottom: '1rem' }}>
        <span style={{
          background: 'linear-gradient(135deg, #0ea5e9, #14b8a6)',
          WebkitBackgroundClip: 'text',
          backgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
          Frequently Asked Questions
        </span>
      </h1>
      <p style={{ 
        fontSize: '1.2rem', 
        color: '#9ca3af', 
        maxWidth: '600px', 
        margin: '0 auto' 
      }}>
        Find answers to the most common questions about Lendefi Markets.
      </p>
    </div>
  );
};

export default FAQHeader;